/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import { TextField } from 'generic/form'
import classnames from 'classnames'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { RaisedButton, CircularProgress } from 'material-ui'

import Request from 'generic/request/Request'
import Login from 'components/authentication/Login'
import ContactDialog from 'components/authentication/Contact'

import * as actions from 'actions/Login'
import * as userActions from 'actions/User'
import * as constants from 'constants/Login'

export const ShowVideoForm = false

class LoginPage extends React.Component {

  constructor (props) {
    super(props)
    autoBind(this)

    this.state = {
      open: false,
      loading: false,
      confirmation: false,
      username: undefined,
      password: undefined,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      }
    }
  }

  handleChange (event, value) {
    const name = event.target.name

    this.setState({
      [name]: value,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      }
    })
  }

  handleSubmit (e) {
    e.preventDefault()
    this.setState({
      loading: true
    })

    actions.login(this.state.username, this.state.password)
      .then(() => {
        return this.props.actions.setUserInformation()
      })
      .then((result) => {
        this.setState({
          loading: false
        })

        if (result && result.success) {
          const pathname = this.props.location.state &&
                           this.props.location.state.from
                            ? this.props.location.state.from.pathname
                            : '/dashboard/'

          this.props.history.push({pathname: pathname})
        }
      })
      .catch((error) => {
        this.handleErrors(error.response)
      })
  }

  handleErrors (error) {
    this.setState({
      loading: false
    })

    if (error && (error.status === 400 || error.status === 401)) {
      this.setState({
        errors: {
          ...this.state.errors,
          errorMessage: R.path(['data', 'errors', 0, 'user_message'], error),
          errorFields: Request.getFieldErrorObject(error.data.field_errors)
        }
      })
    }
  }

  handlePrestationUrgent () {
    this.props.history.push({pathname: '/audio/video/'})
  }

  handleContactDialog () {
    this.setState({
      open: true
    })
  }

  handleConfirmationClose () {
    this.setState({
      confirmation: false
    })
  }

  handleContactCancel ({ success }) {
    this.setState({
      open: false,
      confirmation: success,
    })
  }

  render () {
    return (
      <Login>
        {
          this.state.errors.errorMessage
            ? <h1 className='error-message' style={{textAlign: 'center'}}>
              {this.state.errors.errorMessage}
            </h1>
            : null
        }

        <form onSubmit={this.handleSubmit}>
          <TextField
            floatingLabelText={this.props.intl.formatMessage(constants.messages.USERNAME_LABEL)}
            value={this.state.username}
            onChange={this.handleChange}
            name='username'
            errorText={this.state.errors.errorFields.username}
            meta={{mandatory: true}}
            placeholderMandatory={!R.path(['errors', 'errorFields', 'username'], this.state)}
          />
          <TextField
            floatingLabelText={ this.props.intl.formatMessage(constants.messages.PASSWORD_LABEL) }
            value={this.state.password}
            onChange={this.handleChange}
            type='password'
            name='password'
            errorText={this.state.errors.errorFields.password}
            meta={{mandatory: true}}
            placeholderMandatory={!R.path(['errors', 'errorFields', 'password'], this.state)}
          />
          <div
            className={classnames('row', 'ButtonContainer')} style={{marginLeft: 0, marginRight: 0}}
          >
            {
              this.state.loading
                ? <CircularProgress
                  style={{textAlign: 'center', marginLeft: '46%'}}
                />
                : <div>
                  <RaisedButton
                    label={this.props.intl.formatMessage(constants.messages.LOGIN_LABEL)}
                    primary
                    disabled={Login.MAINTENANCE_LOGIN}
                    type='submit'
                    style={styles.button}
                  />
                  <RaisedButton
                    label={this.props.intl.formatMessage(constants.messages.NO_LOGIN_LABEL)}
                    disabled={Login.MAINTENANCE_LOGIN}
                    onClick={this.handleContactDialog}
                    style={styles.button}
                  />

                  {
                    ShowVideoForm
                      ? <RaisedButton
                        label={this.props.intl.formatMessage(constants.messages.PRESTATION_URGENT_LABEL)}
                        disabled={Login.MAINTENANCE_LOGIN}
                        onClick={this.handlePrestationUrgent}
                        style={styles.button}
                      />
                      : undefined
                  }
                </div>
            }
          </div>
        </form>

        <ContactDialog
          open={this.state.open}
          confirmation={this.state.confirmation}
          handleConfirmationClose={this.handleConfirmationClose}
          handleCancel={this.handleContactCancel}
        />
      </Login>
    )
  }
}

const styles = {
  button: {
    margin: 3,
    minWidth: 180
  }
}

const mapActionsToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  userActions: bindActionCreators(userActions, dispatch),
})

export default withRouter(
  connect(undefined, mapActionsToProps)
  (injectIntl(LoginPage))
)


// WEBPACK FOOTER //
// ./src/components/pages/LoginPage.js